import XRegExp from 'xregexp';

import { username } from 'libs/forms/validators';

export const tag = '(^|\\s)(?<tag>#[\\w-]*)';
// const issue = '~(?<issue>[\\d]+)';
// const relativeIssue = issue.replace('issue', 'relativeissue');
const project = '(?<project>[\\w-]+)';
const file = 'file/(?<path>[\\.\\w\\d/-]+)(#(?<pathhash>[a-f\\d]+))?';
const relativeFile = file.replace(XRegExp('path', 'g'), 'relativepath');
const absoluteFile = `${username}/${project}/${file}`;

export const patterns = {
  mention: XRegExp.union([XRegExp(username), XRegExp(tag)]),
  link: XRegExp(`^(${absoluteFile}|${relativeFile})`, 'g'),
  preview: XRegExp.union(
    [XRegExp(username), XRegExp(tag), XRegExp(relativeFile)],
    'g',
  ),
};
